<template>
    <Btn
        v-click-outside="{ callback: close, when: editMode, whitelist: ['selector'] }"
        :variant="BtnVariant.CUSTOM"
        :disabled="!canEdit"
        :class="[{ 'text-blue-600 bg-blue-200': editMode }, 'hover:text-blue-600 md:px-4']"
        @click.stop="open"
    >
        <template #content>
            <div class="flex items-center">
                <i :class="['icon-' + icon, 'icon mr-2 md:mr-4 flex-shrink-0']" />

                <div class="grid flex-grow flex-shrink text-left">
                    <slot v-if="editMode" />
                    <span
                        v-else
                        class="truncate"
                    >
                        {{ valueName || filterName }}
                    </span>
                </div>

                <i
                    v-if="!editMode && !valueName"
                    class="flex-shrink-0 icon icon-chevron-right ml-4"
                ></i>
                <i
                    v-else
                    class="flex-shrink-0 icon icon-close w-3 h-3 ml-4"
                    @click.stop="() => (editMode ? close() : clear())"
                ></i>
            </div>
        </template>
    </Btn>
</template>

<script>
import { BtnVariant } from '@components/Btn';
/**
 * @slot default
 * @emits open
 * @emits clear
 * @emits close
 */
export default {
    name: 'InputFilter',

    props: {
        // toogles input mode
        modelValue: {
            type: Boolean,
            default: false,
        },
        filterName: {
            type: String,
            required: true,
        },
        valueName: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            required: true,
        },
        canEdit: {
            type: Boolean,
            default: false,
        },
    },
    emits: [
        'input',
        'update:modelValue',
        'clear',
        'close',
        'open',
    ],

    data() {
        return {
            BtnVariant,
            editMode: this.modelValue,
        };
    },

    watch: {
        modelValue(newVal) {
            this.editMode = newVal;
        },
        editMode(newVal, oldVal) {
            if (newVal === oldVal) return;

            this.$emit('input', newVal);
            this.$emit('update:modelValue', newVal);
            this.$emit(newVal ? 'open' : 'close');
        },
    },

    methods: {
        async open() {
            if (this.canEdit) {
                this.editMode = true;
                await this.$nextTick();
            }
        },
        clear() {
            this.close();
            this.$emit('clear');
        },
        close() {
            this.editMode = false;
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.selector:not(.slim)) {
    .vs__actions {
        top: 0.5rem;
    }
}
</style>
